import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import BusinessPartnersItemBlockData from 'app/Models/Content/BusinessPartnersItemBlockData';
import React from 'react';
import {getBackgroundImageProps, getImageProps} from 'app/utilities/ImageProps';

const BusinessPartnersItemBlock = ({data, context}: ComponentProps<BusinessPartnersItemBlockData>) => {
  return (
    <div className='BusinessPartnersItemBlock'>
      <div className='BusinessPartnersItemBlock__background-image' {...getBackgroundImageProps(data.backgroundImage, context)}></div>
      <div className='BusinessPartnersItemBlock__partner-image'>
        <Image {...getImageProps(data.partnerImage, context)} />
      </div>
      <div className='BusinessPartnersItemBlock__item-content'>
        <h3 className='BusinessPartnersItemBlock__item-content__title'>{data.title.value}</h3>
        <p className='BusinessPartnersItemBlock__item-content__description'>{data.description.value}</p>
        <div className='BusinessPartnersItemBlock__item-content__button'>
          <a className='BusinessPartnersItemBlock__item-content__button__link' href={data.buttonLink.value}>
            {data.buttonLinkTitle.value}
          </a>
        </div>
      </div>
    </div>
  );
};

export default BusinessPartnersItemBlock;
